import { useContext } from 'react';
import { SubscriptionContext, ISubscriptionContext } from 'context';

export function useSubscription(): ISubscriptionContext | null {
  const context = useContext(SubscriptionContext);
  return context;
}
